import React from 'react';

export const Box = props => <div className='box'>{props.children}</div>

export const BoxCenter = props => <div className='box has-text-centered'>{props.children}</div>



// WEBPACK FOOTER //
// ./src/components/generic/Box.js